@switch (contentType) {
  @case ('string') {
    <div class="box">
      <div [innerHTML]="content"></div>
    </div>
  }
  @case ('template') {
    <ng-container *ngTemplateOutlet="content; context: context" />
  }
  @case ('component') {
    <ng-container *ngComponentOutlet="content" />
  }
}
<mat-spinner />
